import * as React from 'react';
export default (function (props) {
    return React.createElement(
        'div',
        { className: props.className, onClick: props.onClick },
        props.children
    );
});


//////////////////
// WEBPACK FOOTER
// ./~/antd/es/table/FilterDropdownMenuWrapper.js
// module id = 1390
// module chunks = 0